import React, { useState } from 'react';
import Sidebar from '../Sidebar/Sidebar';


const AddDoctor = () => {
    const [info, setInfo] = useState({});
    const [file, setFile] = useState(null);

    const handleBlur = e => {
        const newInfo = {...info};
        newInfo[e.target.name] = e.target.value;
        setInfo(newInfo);
    }
    const handleFileChange = (e) => {
        const newFile = e.target.files[0];
        setFile(newFile);
    }
    const handleSubmit = () => {
        const formData = new FormData()
        formData.append('file', file);
        formData.append('name', info.name);
        formData.append('email', info.email);

        fetch('http://localhost:5000/addDoctor', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            console.log(data)
        })
        .catch(error => {
            console.error(error)
        })
    }
    return (
        <section style={{ background: '#f4fdfb' }}>
            <div className="ps-0 container-fluid row">
                <div className="col-md-2">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-10">
                    <h5 className='mt-5'>Patients</h5>
                    <form onSubmit={handleSubmit}>
                        <div class="mb-3">
                            <label for="name" className="form-label">Name</label>
                            <input type="text" className="form-control" onBlur={handleBlur} name='name' id="name" placeholder='Your Name'/>
                        </div>
                        <div class="mb-3">
                            <label for="exampleInputEmail1" className="form-label">Email address</label>
                            <input type="email" className="form-control"  onBlur={handleBlur}  name='email' id="exampleInputEmail1" placeholder='Your Email Address'/>
                        </div>
                        <div class="mb-3">
                            <label for="name" className="form-label">Upload Image</label>
                            <input type="file" className="form-control" id="name" name="file" onChange={handleFileChange} placeholder='Upload Image'/>
                        </div>
                        
                        <button type="submit" className="btn btn-primary">Submit</button>
                    </form>
                </div>
            </div>
        </section>
    );
};

export default AddDoctor;